import { TrainingProgramEnds } from 'shared/Constants';
import { APIManager, axios } from 'shared/manager';

const getTrainingDetails = async (): Promise<any> =>
  APIManager.sendGet(
    TrainingProgramEnds.TRAINING_TEMPLATE,
    true,
    {},
    {},
    axios
  );

const getTrainingDetailsByID = async (id: string): Promise<any> =>
  APIManager.sendGet(
    TrainingProgramEnds.TRAINING_TEMPLATE_ID(id),
    true,
    {},
    {},
    axios
  );

const getTrainingPrograms = async (queryString: string): Promise<any> =>
  APIManager.sendGet(
    TrainingProgramEnds.TRAINING_PROGRAMS(queryString),
    true,
    {},
    {},
    axios
  );

const getTrainingProgramDetails = async (id: string): Promise<any> =>
  APIManager.sendGet(
    TrainingProgramEnds.TRAINING_PROGRAM_ID(id),
    true,
    {},
    {},
    axios
  );

const createTrainingProgram = async (data: any): Promise<any> =>
  APIManager.sendPost(
    TrainingProgramEnds.CREATE_TRAINING_PROGRAMS,
    data,
    true,
    {},
    {},
    axios
  );

const deleteTrainingProgram = async (id: string): Promise<any> =>
  APIManager.sendDelete(
    TrainingProgramEnds.TRAINING_PROGRAM_ID(id),
    true,
    {},
    {},
    axios
  );

const updateTrainingProgram = async (data: any, id: any): Promise<any> =>
  APIManager.sendPut(
    TrainingProgramEnds.TRAINING_PROGRAM_ID(id),
    data,
    true,
    {},
    {},
    axios
  );

const createAssignment = async (data: any): Promise<any> =>
  APIManager.sendPost(
    TrainingProgramEnds.CREATE_ASSIGNMENT,
    data,
    true,
    {},
    {},
    axios
  );

const getAssignments = async (id: string): Promise<any> =>
  APIManager.sendGet(
    TrainingProgramEnds.GET_ASSIGNMENTS(id),
    true,
    {},
    {},
    axios
  );

const linkAISystem = async (id: string, data: any): Promise<any> =>
  APIManager.sendPut(
    TrainingProgramEnds.LINK_AI_SYSTEM(id),
    data,
    true,
    {},
    {},
    axios
  );

const resendAssignment = async (id: string, data: any): Promise<any> =>
  APIManager.sendPost(
    TrainingProgramEnds.RESEND_REMINDER_ASSIGNMENTS(id),
    data,
    true,
    {},
    {},
    axios
  );

const getValidToken = async (id: string): Promise<any> =>
  APIManager.sendGet(
    TrainingProgramEnds.TRAINING_TOKEN(id),
    false,
    {},
    {},
    axios
  );

const updateAssignment = async (id: string, data: any): Promise<any> =>
  APIManager.sendPut(
    TrainingProgramEnds.UPDATE_ASSIGNMENTS(id),
    data,
    true,
    {},
    {},
    axios
  );

const getProgressAssignment = async (id: string): Promise<any> =>
  APIManager.sendGet(
    TrainingProgramEnds.GET_PROGRESS_ASSIGNMENT(id),
    true,
    {},
    {},
    axios
  );

export const TrainingPorgramsService = {
  getTrainingDetails,
  getTrainingDetailsByID,
  getTrainingPrograms,
  getTrainingProgramDetails,
  createTrainingProgram,
  deleteTrainingProgram,
  updateTrainingProgram,
  createAssignment,
  getAssignments,
  linkAISystem,
  resendAssignment,
  getValidToken,
  updateAssignment,
  getProgressAssignment,
};
